import React, { useEffect, useState } from 'react';
import HeaderCard from '../../../components/Header/HeaderCard';
import TableList from '../../../components/Tools/TableList';
import { apiService } from '../../../components/Config/api.service';
import HspForm from './HspForm';
import Drawer from '../../../components/Tools/DrawerCustom';

const Hsp = () => {
    const [data, setData] = useState([]);
    const [pagination, setPagination] = useState({
        offset: 0,
        limit: 25,
        total_pages: 1,
        total_count: 0
    });
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [filterBy, setFilterBy] = useState({});
    
    const [selectedId, setSelectedId] = useState(null);

    const handleRowClick = (id) => {
        setSelectedId(id);
        openDrawer();
    };

    const openDrawer = () => {
        setIsDrawerOpen(true);
    };

    const closeDrawer = () => {
        setIsDrawerOpen(false);
    };

    // number of decimals for percentage displays (change to 3 for three decimals)
    const DECIMALS = 2;
    const formatNumber = (v) => {
        const n = parseFloat(v);
        if (isNaN(n)) return '0.00';
        return n.toFixed(DECIMALS);
    };

    const columns = [
        { key: 'employee_name', label: 'Employee' },
        { key: 'month', label: 'Mois' },
        { key: 'hs_15', label: '15%', render: row => formatNumber(row.hs_15) },
        { key: 'hs_40', label: '40%', render: row => formatNumber(row.hs_40) },
        { key: 'hs_60', label: '60%', render: row => formatNumber(row.hs_60) },
        { key: 'hs_100', label: '100%', render: row => formatNumber(row.hs_100) },
    ];

    const fetchAdditionalHours = (page = 1, search = '', filter="") => {
        setLoading(true);

        const offset = (page - 1) * pagination.limit;
        const params = new URLSearchParams();
        params.append('offset', offset);
        params.append('limit', pagination.limit);
        if (search) {
            params.append('search', search);
        }
        if (filter) {
            params.append('filter_by', JSON.stringify(filter));
        }

        apiService.getElement(`/additionalHours?${params.toString()}`)
            .then(response => {
                setData(response.data.additionalHours);
                const responseData = response.data;
                if (responseData.pagination) {
                    const currentPage = Math.floor(responseData.pagination.offset / responseData.pagination.limit) + 1;

                    setPagination({
                        ...responseData.pagination,
                        page: currentPage
                    });
                }
            })
            .catch(error => {
                console.error('There was an error fetching the data!', error);
                setData([]);
                setPagination({
                    offset: 0,
                    limit: 4,
                    total_pages: 1,
                    total_count: 0
                });
            });
        setLoading(false);

    };

    useEffect(() => {
        fetchAdditionalHours(pagination.page, searchTerm, filterBy);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handlePageChange = (page, search, filterBy) => {
        const newSearchTerm = search !== undefined ? search : searchTerm;
        const newFilterBy = filterBy !== undefined ? filterBy : {};
        setSearchTerm(newSearchTerm);
        setFilterBy(newFilterBy);
        
        fetchAdditionalHours(page, newSearchTerm,filterBy);
    };

    const refreshHspList = () => fetchAdditionalHours();

    return (
        <div className="p-6">
            <div className='flex justify-between items-center mb-6'>
                <HeaderCard
                    title="Heures supplémentaires"
                    exportProps={{
                        model_name: "additional_hour",
                        fields: ["employee_id", "month", "hs_15", "hs_40", "hs_60", "hs_100"],
                        filename: "heures_supplementaires_export",
                        importUrl: "/import/additional_hour",
                        onImportSuccess: refreshHspList
                    }}
                />

                <div className="flex justify-between items-center">
                    <button
                        className="btn btn-md bg-[--color-primary] text-white rounded-full mr-2"
                        onClick={() => { openDrawer(); setSelectedId(null); }}
                    >
                        Ajouter Heure Supplémentaire
                    </button>
                </div>
            </div>

            <div className="overflow-x-auto card bg-white shadow-sm rounded-lg p-2">
                    <TableList
                        columns={columns}
                        data={data}
                        onRowClick={row => handleRowClick(row.id)} 
                        pagination={pagination}
                        onPageChange={handlePageChange}
                        searchQuery={searchTerm}
                        setSearchQuery={setSearchTerm}
                        // filterBy={filterBy}
                        // setFilterBy={setFilterBy}
                        showFilter={false}
                        model={"additionalHours"}
                        loading={loading}
                    />
            </div>

            <div className={`fixed inset-0 z-50 ${isDrawerOpen ? 'pointer-events-auto' : 'pointer-events-none'}`}>
                <Drawer isOpen={isDrawerOpen} setIsOpen={setIsDrawerOpen} width={600}>
                    <HspForm
                        setIsDrawerOpen={closeDrawer}
                        id={selectedId}
                        refreshHspList={refreshHspList}
                        
                    />
                </Drawer>

                    
                
            </div>
        </div>
    );
};

export default Hsp;